module.exports = __webpack_public_path__ + "img/ofertas.d9b2f63d.jpg";